<h2 mat-dialog-title style="font-weight: normal; padding: 1.5rem 1.5rem 0px 1.5rem">
	<span fxFlex>{{title}}</span>
	<span fxFlex fxLayoutAlign="end end">
		<mat-icon (click)="closeDialog()" class="primary-light-color" style="cursor: pointer"
			>close</mat-icon
		>
	</span>
</h2>
<mat-progress-bar *ngIf="isUpdating" mode="indeterminate"></mat-progress-bar>
<mat-divider></mat-divider>

<mat-dialog-content style="padding: 1.5rem 1.5rem 1rem 1.5rem; margin: 1px">
	<div *ngIf="fromHotLanesCard" style="margin-top: -1rem">
		<p>
			C4 will analyze your transactions to identify which carrier and lanes you should focus on,
			which ones need work, and score your buying. The transactions you add to the system will help
			us customize pricing data to the lanes and freight you run.
		</p>
		<p>
			You can download the historical load template
			<a class="link" href="{{S3_CSV_TEMPLATE.PRICING_DATA}}" target="_blank">here</a>
			or from the Upload Templates menu any time.
		</p>
		<p>
			All transaction data you provide is private to your account and will never be shown to other
			users. You can choose to remove the data at any time.
		</p>
	</div>
	<div
		style="
			background-color: #f5f5f5;
			border: 1px solid #ccc;
			border-radius: 2px;
			padding: 8.5px;
			font-size: 12px;
		"
	>
		<span>Please select your pricing data file.</span>
		<label for="file">Choose .csv or .xlsx file to open</label>
		<input
			#fileInput
			(change)="handleFileInput($event.target.files)"
			accept=".csv, .xlsx"
			id="file"
			type="file"
		/>
	</div>
</mat-dialog-content>
<mat-divider></mat-divider>

<mat-dialog-actions class="default-dialog-action">
	<div fxFlex fxLayoutAlign="end end" fxLayoutGap="1rem">
		<button (click)="closeDialog()" color="primary" mat-stroked-button>Cancel</button>
		<button
			(click)="getSignedUrl()"
			[disabled]="utilService.isNullOrUndefined(fileData)"
			color="primary"
			mat-raised-button
		>
			Upload
		</button>
	</div>
</mat-dialog-actions>
